export default __webpack_public_path__ + "static/media/bhumika.72eab62f.png";